import HBIcon from "@/components/HBIcon";
import { cleanHtmlTag } from "@/utils/str";
import { useMemoizedFn } from "ahooks";
import classNames from "classnames";
import styles from "../index.module.less";

export default function ContactAvatar({
  name,
  avatarUrl,
  message,
  showRedPoint,
  isCurrent,
  urlname,
  hideClose,
  onDelete,

  ...rest
}) {
  const onAvatarClick = useMemoizedFn((e) => {
    if (!urlname) return;

    e.stopPropagation();
    window.open(`/user/${urlname}`);
  });

  const onDeleteClick = useMemoizedFn((e) => {
    e.stopPropagation();
    onDelete && onDelete();
  });

  return (
    <div
      {...rest}
      className={classNames(styles.contactAvatar, {
        [styles.current]: isCurrent,
      })}
    >
      {!hideClose && (
        <HBIcon
          type="ic_close"
          className={styles.del}
          onClick={onDeleteClick}
          data-gd-click="button_click"
          data-button-name="删除会话"
        />
      )}
      <div className={styles.avatar}>
        <img src={avatarUrl} alt={"联系人头像"} onClick={onAvatarClick} />
        {showRedPoint && <div className={styles.redPoint} />}
      </div>
      <div className={styles.info}>
        <div className={styles.name}>{name}</div>
        <div className={styles.message}>{cleanHtmlTag(message)}</div>
      </div>
    </div>
  );
}
